import { langPath, type Lang } from "@/lib/i18n";

/**
 * An FAQ's URL. Slug-keyed like a post (`faq(slug)` is the only read), so
 * `/faq/<slug>` with no id segment; `library` builds the signed-in twin under
 * /library, where a member's own read decides what they may see. The slug is
 * encoded — backend slugs can carry spaces and diacritics.
 */
export function faqHref(lang: Lang, slug: string | null | undefined, library = false): string {
  return langPath(lang, `${library ? "/library" : ""}/faq/${encodeURIComponent(slug ?? "")}`);
}

/** The FAQ index. */
export function faqIndexHref(lang: Lang, library = false): string {
  return langPath(lang, library ? "/library/faq" : "/faq");
}

/** One section's page: the index with the API's `categoryId` read. */
export function faqSectionHref(lang: Lang, topicId: string, library = false) {
  return `${faqIndexHref(lang, library)}?topic=${encodeURIComponent(topicId)}`;
}
